import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import csCommon from "./locales/cs/common.json";
import enCommon from "./locales/en/common.json";
import skCommon from "./locales/sk/common.json";

const resources = {
  cs: { common: csCommon },
  en: { common: enCommon },
  sk: { common: skCommon },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: ["cs", "en", "sk"],
    nonExplicitSupportedLngs: true,
    fallbackLng: "cs",
    defaultNS: "common",
    ns: ["common"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

export default i18n;
